// extracted by mini-css-extract-plugin
export default {"academyEditLink":"styles_academyEditLink__gN4Xh","academyEditButton":"styles_academyEditButton__BdD7t","fadeIn":"styles_fadeIn__DSL0G"};